module.exports = __webpack_public_path__ + "9d31ab10d5c92f548e1ea7b805689f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-8.png
// module id = 412
// module chunks = 0